import InputErrorText from './InputErrorText.vue'

export default {
    'tl-input-error-text': InputErrorText,
}
